import React from 'react';

import { expVal } from '@confluence/feature-experiments';
import { SPACE_SETTINGS_LANDING_PAGE } from '@confluence/named-routes/entry-points/routes.ts';
import { LoadablePaint } from '@confluence/loadable';
import { CONTAINER_ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { Redirection } from '@confluence/route-manager/entry-points/Redirection.ts';

const LazySpaceAvatarsSettingsRouteComponent = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-AvatarsSettingsRouteComponent" */
				'./SpaceAvatarsSettingsRouteComponent.tsx'
			)
		).SpaceAvatarsSettingsRouteComponent,
});

export const LazySpaceAvatarsSettingsRoute: {
	({
		params: { spaceKey },
	}: {
		params: {
			spaceKey: any;
		};
	}): React.JSX.Element;
	NAVIGATION_PARAMS({
		params: { spaceKey },
	}: {
		params: {
			spaceKey: any;
		};
	}): {
		Screen: {
			pageState: {
				spaceKey: any;
			};
			screenEvent: {
				name: string;
			};
		};
		MainLayout: {
			navView: string;
			spaceKey: any;
		};
	};
} = ({
	params: { spaceKey },
}: {
	params: {
		spaceKey: any;
	};
}): React.JSX.Element => {
	if (!expVal('confluence_approvals_eap', 'isEnabled', false)) {
		return <Redirection name={SPACE_SETTINGS_LANDING_PAGE.name} params={{ spaceKey }} />;
	}

	return <LazySpaceAvatarsSettingsRouteComponent spaceKey={spaceKey} />;
};

LazySpaceAvatarsSettingsRoute.NAVIGATION_PARAMS = ({
	params: { spaceKey },
}: {
	params: {
		spaceKey: any;
	};
}): {
	Screen: {
		pageState: {
			spaceKey: any;
		};
		screenEvent: {
			name: string;
		};
	};
	MainLayout: {
		navView: string;
		spaceKey: any;
	};
} => ({
	Screen: {
		pageState: { spaceKey },
		screenEvent: { name: 'avatarsSettingsScreen' },
	},
	MainLayout: {
		navView: CONTAINER_ADMIN_HOME_ID,
		spaceKey,
	},
});
